"use client";
import style from "./index.module.scss";

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTrigger
} from "@/components/ui/dialog";
import { useIsScreenSizeMatched } from "@/hooks/useMatchScreenSize";
import { fetchCurrentPlan, fetchMe } from "@/lib/client";
import { UserType } from "@/types/account";
import { Coins } from "lucide-react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { ReactNode, useEffect, useState } from "react";

const CreditContent = (props: { creditAmount: number; isSubscriptingPlan: boolean }) => {
  const { creditAmount, isSubscriptingPlan } = props;
  const isScreenNarrow = useIsScreenSizeMatched(["sm"]);

  return (
    <div className={style.credit_container}>
      <Coins />

      {isSubscriptingPlan ? (
        <p>無制限</p>
      ) : (
        <p>
          {creditAmount} {!isScreenNarrow && "クレジット"}
        </p>
      )}
    </div>
  );
};

export function HeaderCredit({ children }: { children: ReactNode }) {
  const planComponent = children;
  const pathname = usePathname();
  const [currentUser, setCurrentUser] = useState<UserType | undefined>();
  const [isSubscriptingPlan, setIsSubscriptingPlan] = useState(false);

  // biome-ignore lint:
  useEffect(() => {
    const fetchCurrentUser = async () => {
      try {
        const currentUser = await fetchMe();
        setCurrentUser(currentUser);
      } catch (_) {}
    };

    const fetchSubscriptingPlan = async () => {
      try {
        const currentPlan = await fetchCurrentPlan();
        const isSubscriptingPlan = currentPlan !== undefined;
        setIsSubscriptingPlan(isSubscriptingPlan);
      } catch (_) {
        setIsSubscriptingPlan(false);
      }
    };

    fetchSubscriptingPlan();
    fetchCurrentUser();
  }, [pathname]);

  if (!currentUser || pathname === "/") {
    return null;
  }

  return (
    <Dialog>
      <DialogTrigger>
        <CreditContent
          creditAmount={currentUser.available_credit}
          // isSubscriptingPlan={isSubscriptingPlan}
          isSubscriptingPlan={currentUser.role === "pro"}
        />
      </DialogTrigger>
      <DialogContent className={style.credit_dialog_content}>
        <DialogHeader className={style.dialog_header}>
          <CreditContent
            creditAmount={currentUser.available_credit}
            // isSubscriptingPlan={isSubscriptingPlan}
            isSubscriptingPlan={currentUser.role === "pro"}
          />
          {currentUser.role !== "pro" && currentUser.available_credit < 30 && (
            <p className={style.lack_credit_text}>クレジットが不足しています</p>
          )}
        </DialogHeader>
        {isSubscriptingPlan && (
          <Link className={style.go_current_plan} href="/settings/current-plan">
            <DialogClose>現在のプランを確認</DialogClose>
          </Link>
        )}
        <div className={style.plan_container}>
          {currentUser.role === "pro" && <p>プラン</p>}
          {currentUser.role !== "pro" && <p>プランを変更してクレジットを無制限にする</p>}
          {planComponent}
        </div>
      </DialogContent>
    </Dialog>
  );
}
